import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Button} from 'react-bootstrap'
import {connectLoadingLock} from '../../core/redux/loading'
import {average, max} from '../../core/mathz'
import Rating from '../../core/components/Rating'
import {DEFAULT_ANSWER_QUERY, queryAnswerStream, queryCampaign, queryActiveCampaign} from '../actions'
import i18n from '../i18n'
import style from './SatisfactionButton.less'

class SatisfactionButton extends Component {
    static propTypes = {
        ticket: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillMount() {
        const {dispatch, ticket} = this.props

        dispatch(queryAnswerStream({...DEFAULT_ANSWER_QUERY, companyUid: ticket.linkedEntities.clientCompany.uid, ticketUid: ticket.uid})).then((response) => {
            const answer = response.stream[0]
            if (answer) {
                return dispatch(queryCampaign(ticket.linkedEntities.clientCompany.uid, answer.campaignUid))
            }
            return dispatch(queryActiveCampaign(ticket.linkedEntities.clientCompany.uid))
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ticket != this.props.ticket) {
            const {dispatch, ticket} = nextProps

            dispatch(queryAnswerStream({...DEFAULT_ANSWER_QUERY, companyUid: ticket.linkedEntities.clientCompany.uid, ticketUid: ticket.uid})).then((response) => {
                const answer = response.stream[0]
                if (answer) {
                    return dispatch(queryCampaign(ticket.linkedEntities.clientCompany.uid, answer.campaignUid))
                }
                return dispatch(queryActiveCampaign(ticket.linkedEntities.clientCompany.uid))
            })
        }

        if (nextProps.stream != this.props.stream
            || nextProps.campaign != this.props.campaign) {
            const {stream, campaign} = nextProps
            const answer = stream[0]

            const score = answer && average({source: answer.answers, identify: (a) => a.score, accuracy: 0.1})
            const maxScore = campaign && max({source: campaign.notationScale, identify: (s) => s.position})
            this.setState({score, maxScore})
        }
    }

    render() {
        const {dispatch, stream, campaign, ticket, ...others} = this.props
        const {score, maxScore} = this.state

        return !!maxScore && (
            <div className={style.default}>
                <Button
                    bsStyle='link'
                    {...others}>
                    <Rating
                        label={i18n.score}
                        range={maxScore}
                        value={score} />
                </Button>
            </div>
        )
    }
}

SatisfactionButton = connectLoadingLock()(SatisfactionButton)

SatisfactionButton = connect((state) => ({
    loading: state.loading,
    stream: state.satisfaction.answer.stream,
    campaign: state.satisfaction.campaign.campaign
}))(SatisfactionButton)

export default SatisfactionButton


// WEBPACK FOOTER //
// ./lib/satisfaction/components/SatisfactionButton.js